export default {
  computed: {
    locations() {
      return this.$page.props.auth.locations.data || this.$page.props.auth.locations
    },

    sortedLocations() {
      return _.sortBy(this.locations, [
        function (o) {
          return o.name
        }
      ])
    },

    currentLocation() {
      return this.$page.props.auth.current_location ? this.$page.props.auth.current_location.data : null
    },

    currentLocationId() {
      return this.currentLocation ? this.currentLocation.id : null
    }
  },

  methods: {
    setCurrentLocation(locationId) {
      this.$inertia.post(route('locations.current.store'), { location_id: locationId })
    }
  }
}
